import React, { useEffect } from 'react';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import './Legal.css';
import '../components/Pages/About/About.css';

const PrivacyPolicy = () => {
  // 确保页面加载时滚动到顶部
  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }, 0);
  }, []);
  
  return (
    <div className="elegant-app">
      <Header />
      
      <main className="elegant-about-container">
        <div className="elegant-about-header">
          <h1 className="elegant-about-title">隐私政策</h1>
          <p className="elegant-about-subtitle">更新日期：2025-04-14 | 生效日期：2025-08-01</p>
        </div>
        
        <div className="elegant-about-section">
          <h2>1. 引言</h2>
          <p>HugTub 海龟汤平台（以下简称"我们"或"本平台"）非常重视用户的隐私和个人信息保护。本隐私政策旨在帮助您了解我们收集、使用、存储和共享您的个人信息的方式，以及您所享有的相关权利。请您在使用我们的服务前，仔细阅读并了解本隐私政策。</p>
        </div>
        
        <div className="elegant-about-section">
          <h2>2. 我们收集的信息</h2>
          <p>2.1 您提供的信息：</p>
          <ul className="elegant-list">
            <li>账户信息：当您注册账户时，我们会收集您的用户名、密码、电子邮件地址等信息。</li>
            <li>个人资料：您可以选择提供头像、个人简介等个人资料信息。</li>
            <li>内容信息：您在平台上创作、发布的海龟汤内容，以及您的评论、回复等。</li>
            <li>通信信息：您与我们客服团队的沟通内容。</li>
          </ul>
          
          <p>2.2 我们自动收集的信息：</p>
          <ul className="elegant-list">
            <li>设备信息：设备型号、操作系统版本、浏览器类型等信息。</li>
            <li>日志信息：您访问的页面、点击的链接、浏览时间等信息。</li>
            <li>位置信息：根据您的 IP 地址，我们可能会收集您的大致位置信息。</li>
            <li>Cookie 和类似技术：我们使用 Cookie 和类似技术收集您的使用情况。</li>
          </ul>
        </div>
        
        <div className="elegant-about-section">
          <h2>3. 我们如何使用您的信息</h2>
          <p>我们可能将收集的信息用于以下目的：</p>
          <ul className="elegant-list">
            <li>提供、维护和改进我们的服务</li>
            <li>创建和管理您的账户</li>
            <li>处理您的反馈和请求</li>
            <li>进行数据分析，以改善用户体验</li>
            <li>发送服务通知和更新</li>
            <li>防止欺诈和滥用行为</li>
            <li>遵守法律法规的要求</li>
          </ul>
        </div>
        
        <div className="elegant-about-section">
          <h2>4. 信息共享与披露</h2>
          <p>我们严格保护您的个人信息，不会出售或出租您的个人信息给任何第三方。但在以下情况下，我们可能会共享您的信息：</p>
          <ul className="elegant-list">
            <li>获得您的明确同意后</li>
            <li>与为我们提供服务的供应商或合作伙伴共享，如云服务提供商</li>
            <li>为遵守法律法规、响应法律程序或政府要求</li>
            <li>为保护我们、用户或公众的权利、财产或安全</li>
            <li>与我们的关联公司共享</li>
            <li>在公司合并、收购或资产转让等交易中共享</li>
          </ul>
        </div>
        
        <div className="elegant-about-section">
          <h2>5. 信息存储与安全</h2>
          <p>5.1 信息存储：我们将在中华人民共和国境内存储和处理您的个人信息。在法律允许的情况下，我们可能会将您的信息传输并存储在其他国家或地区。</p>
          <p>5.2 信息安全：我们采取各种安全措施保护您的个人信息，包括但不限于数据加密、访问控制、安全审计等。但请注意，尽管我们努力保护您的信息，但互联网传输不可能绝对安全。</p>
          <p>5.3 信息保留：我们在实现本政策所述目的所必需的期限内保留您的个人信息，除非法律要求或允许更长的保留期限。</p>
        </div>
        
        <div className="elegant-about-section">
          <h2>6. 您的权利</h2>
          <p>根据适用的法律法规，您可能享有以下权利：</p>
          <ul className="elegant-list">
            <li>访问权：您有权访问我们持有的关于您的个人信息</li>
            <li>更正权：您有权要求更正不准确的个人信息</li>
            <li>删除权：在特定情况下，您有权要求删除您的个人信息</li>
            <li>限制处理权：在特定情况下，您有权限制我们处理您的个人信息</li>
            <li>数据可携带权：您有权以结构化、常用和机器可读的格式接收您的个人信息，并有权将这些信息传输给其他控制者</li>
            <li>反对权：在特定情况下，您有权反对我们处理您的个人信息</li>
            <li>撤回同意权：如果我们基于您的同意处理个人信息，您有权随时撤回同意</li>
          </ul>
          <p>如需行使上述权利，请通过本政策"联系我们"部分提供的联系方式与我们联系。</p>
        </div>
        
        <div className="elegant-about-section">
          <h2>7. Cookie 和类似技术</h2>
          <p>7.1 什么是 Cookie：Cookie 是存储在您设备上的小型文本文件，用于记住您的偏好和设置等信息。</p>
          <p>7.2 我们使用 Cookie 的目的：</p>
          <ul className="elegant-list">
            <li>保持您的登录状态</li>
            <li>记住您的偏好设置</li>
            <li>分析平台使用情况</li>
            <li>改善用户体验</li>
          </ul>
          <p>7.3 管理 Cookie：您可以通过浏览器设置管理或禁用 Cookie。但请注意，禁用 Cookie 可能会影响您使用我们某些服务的功能。</p>
        </div>
        
        <div className="elegant-about-section">
          <h2>8. 儿童隐私</h2>
          <p>我们的服务不面向 16 岁以下的儿童。如果我们发现不小心收集了 16 岁以下儿童的个人信息，我们会立即删除这些信息。如果您认为我们可能收集了 16 岁以下儿童的信息，请通过本政策提供的联系方式与我们联系。</p>
        </div>
        
        <div className="elegant-about-section">
          <h2>9. 隐私政策的更新</h2>
          <p>我们可能会不时更新本隐私政策。当我们对本政策进行重大更改时，我们会在网站上发布通知或直接向您发送通知。我们鼓励您定期查看本政策，以了解我们如何保护您的信息。</p>
        </div>
        
        <div className="elegant-about-section">
          <h2>10. 联系我们</h2>
          <p>如果您对本隐私政策有任何疑问、意见或建议，请通过以下方式与我们联系：</p>
          <p>邮箱：privacy@hugtub.com</p>
          <p>我们会在收到您的请求后 30 天内回复。</p>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default PrivacyPolicy; 